export default __webpack_public_path__ + "injectable_trt_instructions-74b422d8034689c2f67116b4f8590031.pdf";